/**
 * Admin PUT /api/admin/orders/:id/status body `status` value.
 * Must match backend enum (often Mongoose snake_case), not spaced phrases.
 *
 * Keys = exact labels from Orders.js ORDER_STATUS_OPTIONS.
 */
export const DISPLAY_ORDER_STATUS_TO_API = {
  'Order Placed': 'pending',
  'Order Confirmed': 'confirmed',
  Processing: 'processing',
  Packed: 'packed',
  Dispatched: 'dispatched',
  'In Transit': 'in_transit',
  'Out for Delivery': 'out_for_delivery',
  Delivered: 'delivered',
  Cancelled: 'cancelled',
};

/**
 * @param {string} displayOrRaw — UI label ("Order Confirmed") or backend-ish string ("confirmed", "in transit")
 * @returns {string} slug for API
 */
export function displayOrderStatusToApiSlug(displayOrRaw) {
  const trimmed = String(displayOrRaw ?? '').trim();
  if (!trimmed) return '';
  if (DISPLAY_ORDER_STATUS_TO_API[trimmed]) {
    return DISPLAY_ORDER_STATUS_TO_API[trimmed];
  }
  const lower = trimmed.toLowerCase();
  if (lower === 'in transit' || lower === 'in-transit' || lower === 'in_transit') return 'in_transit';
  if (lower === 'out for delivery' || lower === 'out-for-delivery' || lower === 'out_for_delivery') {
    return 'out_for_delivery';
  }
  return lower.replace(/\s+/g, '_').replace(/-/g, '_');
}
